import React from "react";
import blueStone from "./bg1.jpg"; // Replace with actual image path
import brownStone from "./bg1.jpg";
import redMandana from "./bg1.jpg";
import kotaTiles from "./bg1.jpg";
import './Product.css'; // Import the CSS file
import Cart from './Cart';

const Products = () => {
  const products = [
    {
      id: 1,
      title: "Kota Stone Blue",
      description:
        "Renowned for its strength and subtle blue shades, Kota Blue Stone is ideal for flooring and wall cladding, offering durability and a refined, natural look to any space.",
      image: blueStone,
    },
    {
      id: 2,
      title: "Kota Stone Brown",
      description:
        "Featuring rich brown tones, Kota Brown Stone adds a warm, earthy elegance to floors and walls, combining aesthetic appeal with exceptional strength for long-lasting construction solutions.",
      image: brownStone,
    },
    {
      id: 3,
      title: "Red Mandana Stone",
      description:
        "Red Mandana Stone offers striking red hues and excellent durability, perfect for adding a bold, vibrant look to both interior and exterior spaces, with its unique texture and resilience.",
      image: redMandana,
    },
    {
      id: 4,
      title: "Kota Stone Tiles",
      description:
        "Kota Stone Tiles provide a versatile, durable flooring solution with natural charm. Their smooth finish and variety of shades make them perfect for enhancing both modern and traditional spaces.",
      image: kotaTiles,
    },
  ];

  return (
    <section className="products-section">
      <div className="products-container">
        <h1 className="products-title">Our Products</h1>
        <p className="products-description">
          Kota Stone is a highly popular and versatile natural stone, widely used for wall
          cladding, flooring, building facades, and paving. Known for its durability and
          strength, it's a top choice for both residential and commercial projects.
        </p>

        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <img src={product.image} alt={product.title} className="product-image" />
              <h3 className="product-title">{product.title}</h3>
              <p className="product-text">{product.description}</p>
            </div>
          ))}
        </div>
      </div>
{/* Reuse Cart Component */}
<Cart />

    </section>
    

  );
};

export default Products;
